<template>
  <div class="regulation-details">
    <!-- 搜索栏 -->
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" size="small">
        <!-- <el-form-item label="资产码">
          <el-input v-model="searchForm.assetCode" placeholder="请输入" clearable style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="枪号">
          <el-input v-model="searchForm.gunNumber" placeholder="请输入" clearable style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="调控类型">
          <el-select v-model="searchForm.regulationType" placeholder="请选择" clearable style="width: 150px">
            <el-option label="全部" value=""></el-option>
            <el-option label="升功率" value="increase"></el-option>
            <el-option label="降功率" value="decrease"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="站点名称">
          <el-input v-model="searchForm.siteName" placeholder="请输入所属站点的名称" clearable style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="调控时间范围">
          <el-date-picker v-model="searchForm.dateRange" type="datetimerange" align="right" start-placeholder="开始日期"
            end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" border stripe highlight-current-row row-key="id" style="width: 100%" height="calc(100vh - 280px)">
        <el-table-column prop="ID" label="序号" width="160" align="center"></el-table-column>
        <el-table-column label="资产码" prop="assets_code" width="220" align="center">
          <template slot-scope="{ row }">
            <div class="show_assets_code" @click="showTripletDetail(row.assets_code)">{{ row.assets_code }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="gun_no" label="枪号" min-width="100"></el-table-column>
        <el-table-column prop="site_name" label="站点名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="cabinet_name" label="一体柜名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="strate_up_down" label="调控类型" width="100" align="center">
          <template slot-scope="scope">
            <span :class="getTypeClass(scope.row.strate_up_down)">{{ getTypeText(scope.row.strate_up_down) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="powerBefore" label="调控前功率" width="120" align="right">
          <template slot-scope="scope">{{ scope.row.strate_power_before }} kWh</template>
        </el-table-column>
        <el-table-column prop="powerAfter" label="调控后功率" width="120" align="right">
          <template slot-scope="scope">{{ scope.row.strate_power_after }} kWh</template>
        </el-table-column>
        <el-table-column prop="srate_way" label="调控方式" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ getSrateWayText(scope.row.srate_way) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="strate_start_time" label="调控开始时间" width="170" align="center"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="170" align="center"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :current-page="currentPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
      </div>
    </el-card>
    <tripletDetail ref="tripletDetail"></tripletDetail>
  </div>
</template>

<script>
import tripletDetail from "../control/_triplet_detail.vue"

import {
  getCtrDetailPageListApi
} from '@/api/dev_archive';
import { formatDate } from "@/utils/tools.js";

export default {
  name: "RegulationDetails",
  components: {
    tripletDetail
  },
  data() {
    return {
      searchForm: {
        assetCode: "",
        gunNumber: "",
        regulationType: "",
        siteName: '',
        dateRange: []
      },
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1
    }
  },
  mounted() {
    this.loadTableData()
  },
  methods: {
    showTripletDetail(assetsCode) {
      this.$refs.tripletDetail.showTripletInfo(assetsCode)
    },

    // 加载表格数据
    loadTableData() {

      let requestData = {
        page: this.currentPage,
        pagesize: this.pageSize
      }

      if (this.searchForm.siteName && this.searchForm.siteName.trim().length > 0) {
        requestData.site_name = this.searchForm.siteName
      }
      
      if(this.searchForm.dateRange && Array.isArray(this.searchForm.dateRange) && this.searchForm.dateRange.length === 2){
        requestData.start_time = formatDate(this.searchForm.dateRange[0]);
        requestData.end_time = formatDate(this.searchForm.dateRange[1]);
      }

      getCtrDetailPageListApi(requestData).then((res) => {
        // onsole.log(res)
        this.tableData = res.data || [];
        this.total = res.total;
      })

      
    },

    // 获取调控类型文本
    getTypeText(type) {
      const typeMap = {
        1: "升功率",
        2: "降功率"
      }
      return typeMap[type] || type
    },

    // 获取调控类型样式类
    getTypeClass(type) {
      const classMap = {
        1: "type-increase",
        2: "type-decrease"
      }
      return classMap[type] || ""
    },

    getSrateWayText(srate_way){
      const wayMap = {
        1: "跳合闸",
        2: "揉控"
      }
      return wayMap[srate_way] || srate_way
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.loadTableData()
    },

    // 每页条数变化
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadTableData()
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadTableData()
    }
  }
}
</script>

<style scoped lang="scss">
.regulation-details {
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  overflow: hidden;
  box-sizing: border-box;
}

.search-card {
  flex-shrink: 0;

  ::v-deep .el-card__body {
    padding: 12px 16px;
  }
}

.table-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;

  ::v-deep .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 12px;
    overflow: hidden;
  }
}

.pagination-container {
  margin-top: 12px;
  text-align: right;
  flex-shrink: 0;
}

// 调控类型颜色
.type-increase {
  color: #67c23a;
  font-weight: 600;
}

.type-decrease {
  color: #f56c6c;
  font-weight: 600;
}
</style>
